import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const LogoutFrame: React.FC = () => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.logoutRedirect();
  });

  return null;
};

export default LogoutFrame;
